export default function getMasterInfo(masterType, enabled, order, socialParams) {
  return {
    masterType,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    order: order || {
      top: [],
      middle: [],
      bottom: []
    },
    enabled: enabled || {
      Title: false,
      Description: false,
      Social: false,
      CustomButton: false
    },
    titleParams: {
      title: 'dummy',
      horizontalAlignment: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    descriptionParams: {
      description: 'dummy_desc',
      horizontalAlignment: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    customButtonParams: {
      options: {
        customButtonText: 'dummy-button-text'
      },
      horizontalAlignment: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    socialParams: socialParams || {
      viewMode: '',
      options: {
        galleryTextAlign: 'DUMMY',
        loveButton: false,
        allowSocial: false,
        loveCounter: false,
        allowDownload: false,
        hasThumbnails: false
      },
      horizontalAlignment: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  };
}
//# sourceMappingURL=getMasterInfo.js.map